module.exports = __webpack_public_path__ + "img/mission_Image_three.15bc7656.png";